import Vue from 'vue'
import $ from 'jquery'
import axios from 'axios'

const LoginApi = {
  data: {
    urlLogo: './../../assets/Logo.png',
    urlLogin: '/api/user/v1/login',
    urlLogout: '/api/user/v1/logout',
    urlRgister: '/v1/register'
  },
  doLogin (postData, onLoginSuccess, onLoginFailed) {
    var cmp = this
    Vue.prototype.$api.showIdle()
    $.post(Vue.prototype.$config.host + this.data.urlLogin, postData, function (data) {
      Vue.prototype.$api.hideIdle()
      console.log(data)
      if (!data.success) {
        cmp.onLoginFailed(data)
        if (onLoginFailed) {
          onLoginFailed(data)
        }
        return false
      } else {
        cmp.onLoginOk(data)
        if (onLoginSuccess) {
          onLoginSuccess(data)
        }
        return true
      }
    })
      .catch(function (error, a, b, c) {
        Vue.prototype.$api.hideIdle()
        console.log(error, a, b, c)
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data)
          console.log(error.response.status)
          console.log(error.response.headers)
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message)
        }
        if (onLoginFailed) {
          onLoginFailed()
        }
      })
  },
  doLogout (fnSuccess, fnError) {
    let url = Vue.prototype.$config.host + this.data.urlLogout
    if (!Vue.prototype.$api.getCredentials()) {
      if (fnError) {
        fnError()
      }
      Vue.prototype.$api.hideIdle()
      return
    }
    Vue.prototype.$api.showIdle()
    let params = {
      time: new Date().getTime(),
      token: Vue.prototype.$api.getCredentials().authToken
    }

    axios({
      method: 'get',
      params: params,
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          fnSuccess(response.data)
        }
      }).catch(error => {
        console.log(error.response)
        Vue.prototype.$api.hideIdle()
        if (fnError) {
          fnError(error.response)
        } else {
          Vue.prototype.$eventHub.$emit('errorDlg', error.response)
        }
      })
  },
  onLoginFailed (data) {
    console.log('login failed', data)
    Vue.prototype.$api.credentials = null
    Vue.prototype.$api.setCredentials()
  },
  onLoginOk (data) {
    var credits = {
      'authorized': true,
      'authToken': data.authToken,
      'user': data.username,
      'data': data
    }
    Vue.prototype.$api.setCredentials(credits)
    $.ajaxSetup({
      headers: {
        'X-Auth-Token': data.authToken
      }
    })
    if (window.jQuery) {
      window.jQuery.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
    if (window.$) {
      window.$.ajaxSetup({
        headers: {
          'X-Auth-Token': data.authToken
        }
      })
    }
  }
}
export default LoginApi



// WEBPACK FOOTER //
// ./src/components/login/Login.js